



















































































































































































































































































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import { VueEditor } from "vue2-editor";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import AppConsts from "@/lib/appconst";
import CreatesalesOrderRequestLineDto from "../../../store/entities/sale-order-request/create-sales-order-request-line";
import CreatesalesOrderRequestDto from "../../../store/entities/sale-order-request/create-sales-order-request";
import Customer from "../../../store/entities/customers/customer";
import columns from "./create-sales-order-request-line-columns";
import Address from "../../../store/entities/address";
import AddressModal from "../../components/address-modal.vue";
import ProductForSelect from "@/store/entities/products/product-for-select";
import _ from "lodash";

class PagesalesOrderRequestLineRequest extends PageRequest {
  sku: string;
}
@Component({
  components: { AddressModal, "vue-editor":  VueEditor },
})
export default class CreatesalesOrderRequest extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  addressModalShow: boolean = false;
  pagerequest: PagesalesOrderRequestLineRequest = new PagesalesOrderRequestLineRequest();
  salesOrderRequest: CreatesalesOrderRequestDto = new CreatesalesOrderRequestDto();
  salesOrderRequestLines: Array<CreatesalesOrderRequestLineDto> = new Array<
    CreatesalesOrderRequestLineDto
  >();
  salesOrderRequestLinesPerPage: Array<
    CreatesalesOrderRequestLineDto
  > = new Array<CreatesalesOrderRequestLineDto>();
  filterTotalCount: number = 0;
  sku: string = "";
  qty: number = 1;
  warehouses = [];
  customer: Customer = new Customer();
  customers: Array<Customer> = new Array<Customer>();
  customerKeyword: string = "";
  spinShow: boolean = false;
  customerLoading: boolean = false;
  sorSelectedAddress: Address = new Address();
  objectLoading: boolean = false;
  productName: string = "";
  products: Array<ProductForSelect> = new Array<ProductForSelect>();
  appCustom = _.get(Util.abp, "custom", []);
  bizTypes = _.get(this.appCustom, ["wms.So", "BizType"], []);
  outboundModes = _.get(this.appCustom, ["wms.So", "OutboundMode"], []);
  inventModels = _.get(this.appCustom, ["wms.Product", "InventModel"], []);
  searchProduct_OnPress = _.debounce(
    this.searchProductForSelect,
    AppConsts.debounceDelayTime,
    {
      leading: false,
      trailing: true,
    }
  );
  searchCustomer_OnPress = _.debounce(
    this.searchCustomers,
    AppConsts.debounceDelayTime,
    {
      leading: false,
      trailing: true,
    }
  );
  get store() {
    return this.$store.state.saleOrderRequest;
  }
  get client() {
    return this.$store.state.session.client;
  }
  get clientCode() {
    return this.$store.state.session.client.code;
  }

  get conditionTypes() {
    var re = this.$store.state.masterData.conditionTypes;
    this.salesOrderRequest.conditionTypeCode = re.length === 0 ? "" : re[0].id;
    return re;
  }
  get shippingServices() {
    var re = this.$store.state.client.clientShippingServices;
    return re;
  }
  get assetTypes() {
    var re = this.$store.state.client.clientAssetTypes;
    this.salesOrderRequest.assetTypeCode = re.length === 0 ? "" : re[0].id;
    return re;
  }
  @Watch("client")
  async getClientShippingServices() {
    if (
      _.isNil(this.client) ||
      _.isNil(this.clientCode) ||
      _.isEmpty(this.clientCode) ||
      (!_.isNil(this.$store.state.client.clientShippingServices) &&
        this.$store.state.client.clientShippingServices.length > 0)
    )
      return;
    await this.$store.dispatch({
      type: "client/getClientShippingServices",
      data: this.clientCode,
    });
  }
  @Watch("client")
  async getClientAssetTypeServices() {
    if (
      _.isNil(this.client) ||
      _.isNil(this.clientCode) ||
      _.isEmpty(this.clientCode) ||
      (!_.isNil(this.$store.state.client.clientAssetTypes) &&
        this.$store.state.client.clientAssetTypes.length > 0)
    )
      return;
    await this.$store.dispatch({
      type: "client/getClientAssetTypeServices",
      data: this.clientCode,
    });
  }
  async getFeatureConditionTypes() {
    await this.$store.dispatch({
      type: "masterData/getFeatureConditionTypes",
      data: { featureCode: AppConsts.featureConditionType.SO_Create },
    });
  }
  async getWarehouses() {
    if (
      !_.isNil(this.$store.state.warehouse.warehousesForSelect) &&
      this.$store.state.warehouse.warehousesForSelect.length > 0
    ) {
      this.setWarehouses();
      return;
    }
    await this.$store
      .dispatch({
        type: "warehouse/getListForSelect",
      })
      .then(() => {
        this.setWarehouses();
      });
  }
  setWarehouses() {
    this.warehouses = this.$store.state.warehouse.warehousesForSelect;
    this.salesOrderRequest.warehouseCode =
      this.warehouses.length === 0 ? "" : this.warehouses[0].id;
  }
  getOutboundModes() {
    this.$set(
      this.salesOrderRequest,
      "outboundMode",
      this.outboundModes.length === 0 ? "" : this.outboundModes[0].code
    );
  }

  updateAddress() {
    if (!Util.isNull(this.sorSelectedAddress)) {
      this.salesOrderRequest.shippingFullAddress = this.sorSelectedAddress.fullAddress;
      this.salesOrderRequest.shippingProvinceId = this.sorSelectedAddress.provinceId;
      this.salesOrderRequest.shippingDistrictId = this.sorSelectedAddress.districtId;
      this.salesOrderRequest.shippingWardId = this.sorSelectedAddress.wardId;
      this.salesOrderRequest.shippingAddressNo = this.sorSelectedAddress.addressNo;
    } else {
      this.salesOrderRequest.shippingFullAddress = "";
      this.salesOrderRequest.shippingProvinceId = 0;
      this.salesOrderRequest.shippingDistrictId = null;
      this.salesOrderRequest.shippingWardId = null;
      this.salesOrderRequest.shippingAddressNo = "";
    }
  }
  openModalAddress() {
    this.addressModalShow = true;
  }
  changeInventModel(value) {
    this.salesOrderRequest.inventModel = value;
  }

  changeCustomer(val) {
    if (Util.isNull(this.customer.id)) {
      this.sorSelectedAddress = null;
      this.salesOrderRequest.customerId = null;
      this.salesOrderRequest.customerCode = "";
      this.salesOrderRequest.contactName = "";
      this.salesOrderRequest.contactPhone = "";
      this.salesOrderRequest.shippingFullAddress = "";
    } else {
      var selectedCustomer = this.customers.find(
        (i) => i.id === this.customer.id
      );
      this.customer = selectedCustomer;
      this.sorSelectedAddress = this.customer.customerAddress;
      this.salesOrderRequest.customerId = this.customer.id;
      this.salesOrderRequest.customerCode = this.customer.code;
      this.salesOrderRequest.contactName = this.customer.name;
      this.salesOrderRequest.contactPhone = this.customer.phone;
    }
    this.updateAddress();
  }
  async changeWarehouseCode() {
    this.resetList();
  }
  async searchCustomers(keyword) {
    if (Util.isEmpty(keyword)) return;
    this.customerLoading = true;
    this.$store
      .dispatch({
        type: "customer/searchCustomerForSelect",
        data: {
          keyWord: keyword,
        },
      })
      .then((result) => {
        this.customers = result;
        this.customerLoading = false;
      });
  }
  async searchProductForSelect(keyword) {
    if (
      Util.isEmpty(keyword) ||
      keyword.length < AppConsts.keyWordAtleastLength
    )
      return;
    this.objectLoading = true;
    this.$store
      .dispatch({
        type: "product/searchProductForSelect",
        data: {
          clientCode: this.clientCode,
          keyWord: keyword,
        },
      })
      .then((result) => {
        this.products = result;
      })
      .finally(() => {
        this.objectLoading = false;
      });
  }
  changeProduct() {
    if (Util.isNull(this.sku) || Util.isEmpty(this.sku)) {
      this.productName = "";
      return;
    }
    var product = _.find(this.products, ["sku", this.sku]);
    if (Util.isNull(product)) {
      this.productName = "";
      Util.showErrorMsg(this, "Error.ProductNotExist");
      return;
    }
    this.productName = product.name;
  }
  async addProduct() {
    if (Util.isNull(this.sku) || Util.isEmpty(this.sku)) {
      Util.showErrorMsg(this, "Error.SkuRequired");
      return;
    }
    var items = this.salesOrderRequestLines;
    var existedItems = items.filter((item) => item.sku === this.sku);
    if (existedItems.length > 0) {
      Util.showErrorMsg(this, "Error.SkuExisted");
      return;
    } else {
      this.$store
        .dispatch({
          type: "product/checkClientProductInvBalBySku",
          data: {
            sku: this.sku.trim(),
            qty: this.qty,
            clientCode: this.clientCode,
            warehouseCode: this.salesOrderRequest.warehouseCode,
            customerCode: this.salesOrderRequest.customerCode,
            assetTypeCode: this.salesOrderRequest.assetTypeCode,
            conditionTypeCode: this.salesOrderRequest.conditionTypeCode,
            markPreOrder: this.salesOrderRequest.isPreOrder,
          },
        })
        .then((product) => {
          if (!_.isNil(product)) {
            this.addProductToSorLine(product);
          }
        })
        .catch((error) => {
          console.log("addProduct", error);
        })
        .finally(() => {
          this.spinShow = false;
        });
    }
  }
  addProductToSorLine(product: any) {
    var newLine = new CreatesalesOrderRequestLineDto();
    newLine = {
      orderNo: 0,
      sku: product.sku,
      productName: product.name,
      productId: product.id,
      orderQty: this.qty,
      productPrice: product.price,
      price: product.price,
      vatPercent: 0,
      productType: product.productType,
    };
    this.salesOrderRequestLines.push(newLine);
    this.pageSalesOrderRequestLinesChange();
    this.sku = "";
    this.qty = 1;
  }
  async checkProductInvBal(row: any, index: number) {
    var item = this.salesOrderRequestLinesPerPage[index];
    if (item.productType === AppConsts.productTypes.service) return;

    var newValue = row.orderQty;
    if (
      _.isNil(this.salesOrderRequest.isPreOrder) ||
      !this.salesOrderRequest.isPreOrder
    ) {
      this.spinShow = true;
      this.$store
        .dispatch({
          type: "product/checkClientProductInvBal",
          data: {
            sku: item.sku,
            productId: item.productId,
            qty: newValue,
            clientCode: this.clientCode,
            warehouseCode: this.salesOrderRequest.warehouseCode,
            assetTypeCode: this.salesOrderRequest.assetTypeCode,
            conditionTypeCode: this.salesOrderRequest.conditionTypeCode,
          },
        })
        .then((isEnough) => {
          var line = this.salesOrderRequestLines.find(
            (i) => i.productId === item.productId
          );
          if (_.isNil(isEnough) || !isEnough) {
            newValue = line.orderQty;
          }
          line.orderQty = newValue;
          this.salesOrderRequestLinesPerPage[index].orderQty = newValue;
          row.orderQty = newValue;
        })
        .catch((error) => {
          console.log("checkProductInvBal", error);
        })
        .finally(() => {
          this.spinShow = false;
        });
    }
  }
  onchangeProductVatPercent(row: any, index: number) {
    var item = this.salesOrderRequestLinesPerPage[index];
    var newValue = row.vatPercent;
    this.salesOrderRequestLinesPerPage[index].vatPercent = newValue;
    var line = this.salesOrderRequestLines.find(
      (i) => i.productId === item.productId
    );
    line.vatPercent = newValue;
    row.vatPercent = newValue;
  }
  onchangeProductPrice(row: any, index: number) {
    var item = this.salesOrderRequestLinesPerPage[index];
    var newValue = row.price;
    this.salesOrderRequestLinesPerPage[index].price = newValue;
    var line = this.salesOrderRequestLines.find(
      (i) => i.productId === item.productId
    );
    line.price = newValue;
    row.price = newValue;
  }
  async save() {
    (this.$refs.salesOrderRequestForm as any).validate(
      async (valid: boolean) => {
        if (valid) {
          this.$Modal.confirm({
            title: this.L("Tips"),
            content: this.L("Confirm.CreateSalesOrderRequest"),
            okText: this.L("Yes"),
            cancelText: this.L("No"),
            onOk: async () => {
              this.spinShow = true;
              var lines = this.salesOrderRequestLines.map((item) => {
                return {
                  sku: item.sku,
                  productId: item.productId,
                  qty: item.orderQty,
                  configPrice: item.price,
                  tax: item.vatPercent,
                  warehouseCode: this.salesOrderRequest.warehouseCode,
                };
              });
              this.salesOrderRequest.lines = lines;
              this.salesOrderRequest.clientCode = this.clientCode;
              this.$store
                .dispatch({
                  type: "saleOrderRequest/create",
                  data: this.salesOrderRequest,
                })
                .then(() => {
                  Util.showSuccessMsg(this, "Success.CreateSalesOrderRequest");
                  this.reset();
                  this.onGoBack();
                })
                .catch((error) => {
                  console.log("create SOR", error);
                })
                .finally(() => {
                  this.spinShow = false;
                });
            },
          });
        }
      }
    );
  }
  onGoBack() {
    this.$root.$router.push({ name: "saleorder-request" });
  }

  remove(index: number) {
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: this.L(`Confirm.RemoveSalesOrderRequestProduct`),
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: async () => {
        var item = this.salesOrderRequestLinesPerPage[index];
        var items = this.salesOrderRequestLines.filter(
          (i) => i.productId != item.productId
        );
        this.salesOrderRequestLines = items;
        await this.getpage();
      },
    });
  }

  reset() {
    this.pagerequest = new PagesalesOrderRequestLineRequest();
    this.sku = "";
    this.qty = null;
    this.customer = null;
    this.customers = new Array<Customer>();
    this.customerKeyword = "";
    this.customerLoading = false;
    this.sorSelectedAddress = new Address();
    this.salesOrderRequest = new CreatesalesOrderRequestDto();
    this.salesOrderRequestLines = new Array<CreatesalesOrderRequestLineDto>();
    this.salesOrderRequestLinesPerPage = new Array<
      CreatesalesOrderRequestLineDto
    >();
    this.filterTotalCount = 0;
    this.productName = "";
    this.products = new Array<ProductForSelect>();
    this.objectLoading = false;
  }

  resetList() {
    if (this.salesOrderRequestLines.length > 0) {
      this.$Modal.confirm({
        title: this.L("Tips"),
        content: this.L(`Confirm.ResetSalesOrderRequestDetails`),
        okText: this.L("Yes"),
        cancelText: this.L("No"),
        onOk: async () => {
          this.salesOrderRequestLines = new Array<
            CreatesalesOrderRequestLineDto
          >();
          await this.getpage();
        },
      });
    }
  }

  get list() {
    var re = this.salesOrderRequestLinesPerPage;
    var startIndex = (this.currentPage - 1) * this.pageSize;
    var index = 0;
    re.forEach(function(item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }

  get loading() {
    return this.store.loading;
  }

  pageChange(page: number) {
    this.$store.commit("saleOrderRequest/setCurrentPage", page);
    this.getpage();
  }

  pagesizeChange(pagesize: number) {
    this.$store.commit("saleOrderRequest/setPageSize", pagesize);
    this.getpage();
  }

  getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    this.pageSalesOrderRequestLinesChange();
  }

  pageSalesOrderRequestLinesChange() {
    var items = this.salesOrderRequestLines;
    if (
      !Util.isNull(this.pagerequest.sku) &&
      !Util.isEmpty(this.pagerequest.sku)
    ) {
      items = items.filter(
        (item) => item.sku.indexOf(this.pagerequest.sku) >= 0
      );
    }
    this.filterTotalCount = items.length;
    this.salesOrderRequestLinesPerPage = Util.pagingItems(
      items,
      this.pageSize,
      this.currentPage
    );
  }

  get pageSize() {
    return this.store.pageSize;
  }

  get totalCount() {
    return this.filterTotalCount;
  }

  get currentPage() {
    return this.store.currentPage;
  }

  async created() {
    this.spinShow = true;
    try {
      this.customer.customerAddress = new Address();
      await this.getWarehouses();
      this.getOutboundModes();
      await this.getFeatureConditionTypes();
      this.spinShow = false;
    } catch (error) {
      console.log("exception", error);
      this.spinShow = false;
    }
  }
  validateBizType(rule, value, callback) {
    if (
      !_.isNil(this.salesOrderRequest.autoCreateSO) &&
      this.salesOrderRequest.autoCreateSO &&
      (_.isNil(value) || _.isEmpty(value))
    ) {
      callback(
        new Error(this.L("Error.RequiredField0", undefined, this.L("BizType")))
      );
    } else {
      callback();
    }
  }
  validateShippingService(rule, value, callback) {
    if (
      !_.isNil(this.salesOrderRequest.autoCreateSO) &&
      this.salesOrderRequest.autoCreateSO &&
      (_.isNil(value) || _.isEmpty(value))
    ) {
      callback(
        new Error(
          this.L("Error.RequiredField0", undefined, this.L("ShippingService"))
        )
      );
    } else {
      callback();
    }
  }
  columns = columns;
  salesOrderRequestRule = {
    warehouseCode: [
      {
        required: true,
        message: this.L("Error.RequiredField", undefined, this.L("Warehouse")),
        trigger: "blur",
      },
    ],
    bizType: [{ validator: this.validateBizType, trigger: "blur" }],
    shippingServiceCode: [
      { validator: this.validateShippingService, trigger: "blur" },
    ],
    outboundMode: [
      {
        required: true,
        message: this.L(
          "Error.RequiredField",
          undefined,
          this.L("OutboundMode")
        ),
        trigger: "blur",
      },
    ],
    customerCode: [
      {
        required: true,
        type: "string",
        message: this.L(
          "Error.RequiredField",
          undefined,
          this.L("CustomerCode")
        ),
        trigger: "blur",
      },
    ],
    contactName: [
      {
        required: true,
        type: "string",
        message: this.L(
          "Error.RequiredField",
          undefined,
          this.L("ContactName")
        ),
        trigger: "blur",
      },
    ],
    contactPhone: [
      {
        required: true,
        type: "string",
        message: this.L(
          "Error.RequiredField",
          undefined,
          this.L("ContactPhone")
        ),
        trigger: "blur",
      },
    ],
    shippingFullAddress: [
      {
        required: true,
        type: "string",
        message: this.L(
          "Error.RequiredField",
          undefined,
          this.L("ShippingAddress")
        ),
        trigger: "blur",
      },
    ],
  };
}
